import { ModelBase } from '../../core/model/model-base';
import { ObjectComponent } from './object-component';

export class BuildingSpace extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.buildingId = dataContext.buildingId;
      this.buildingSpaceTypeId = dataContext.buildingSpaceTypeId;
      this.caption = dataContext.caption;
      this.spaceNumber = dataContext.spaceNumber;
      this.id = dataContext.id;
      this.area = dataContext.area;
      this.components = Array.isArray(dataContext.components) ? dataContext.components.map(c => new ObjectComponent(c)) : [];
    }
  }

  buildingId: string;
  buildingSpaceTypeId: string;
  caption: string;
  spaceNumber: string;
  area: number;
  components: ObjectComponent[];

  toString() {
    if (this.spaceNumber) return `${this.caption} ${this.spaceNumber}`;
    return `${this.caption}`;
  }
}
